import create from './create';
import get from './get';

export default [create, get];
